import { NgOptimizedImage } from "@angular/common";
import { Component, input } from "@angular/core";
import { DirectusTranslationPipe } from "../../../../../../common/pipes/directus-translation.pipe";
import { GetDirectusImagePipe } from "../../../../../../common/pipes/get-directus-image.pipe";
import { ItemsHeaderBlock } from "../../../../../api/packbo/models/items-header-block";

@Component({
    selector: "packbo-full-header",
    templateUrl: "./full-header.template.html",
    imports: [DirectusTranslationPipe, NgOptimizedImage, GetDirectusImagePipe],
    styleUrls: ["./full-header.styles.css"]
})
export class FullHeaderComponent {
    public readonly headerBlock = input.required<ItemsHeaderBlock>();
}
